import $ from 'jquery';

export function ajax(options) {
    return new Promise((resolve) => {
        $.ajax({
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            ...options,
            success: (data) => {
  
                resolve({
                    success: true,
                    data: data
                });
            },
            error: () => {
                resolve({
                    success: false
                });
            }
        })
    });
}